<template>
  <div class="carousel-wrapper">
    <carousel :per-page="1" class="carousel" v-if="this.authType === 'signup' || this.authType === 'partner'">
      <slide>
        <div class="slide-item slide-item0">
          <div class="slide-content">
            <div class="slide-txt">
              <p class="slide-title">{{$t('auth.carousel.slide0.title')}}<br><strong>{{$t('auth.carousel.slide0.subtitle')}}</strong></p>
              <p>{{$t('auth.carousel.slide0.text0')}}</p>
              <p><strong>{{$t('auth.carousel.slide0.text1')}}</strong></p>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-item slide-item1">
          <div class="slide-content">
            <div class="slide-txt">
              <p class="slide-step">{{$t('auth.carousel.slide1.step')}}</p>
              <p class="slide-title">{{$t('auth.carousel.slide1.title')}}<br><strong>{{$t('auth.carousel.slide1.subtitle')}}</strong></p>
              <p>{{$t('auth.carousel.slide1.text0')}}</p>
              <p><strong>{{$t('auth.carousel.slide1.text1')}}</strong></p>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-item slide-item2">
          <div class="slide-content">
            <div class="slide-txt">
              <p class="slide-step">{{$t('auth.carousel.slide2.step')}}</p>
              <p class="slide-title">{{$t('auth.carousel.slide2.title')}}<br><strong>{{$t('auth.carousel.slide2.subtitle')}}</strong></p>
              <p>{{$t('auth.carousel.slide2.text0')}}</p>
              <p><strong>{{$t('auth.carousel.slide2.text1')}}</strong></p>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-item slide-item3">
          <div class="slide-content">
            <div class="slide-txt">
              <p class="slide-step">{{$t('auth.carousel.slide3.step')}}</p>
              <p class="slide-title">{{$t('auth.carousel.slide3.title')}}<br><strong>{{$t('auth.carousel.slide3.subtitle')}}</strong></p>
              <p>{{$t('auth.carousel.slide3.text0')}}</p>
              <p><strong>{{$t('auth.carousel.slide3.text1')}}</strong></p>
            </div>
          </div>
        </div>
      </slide>
    </carousel>

    <carousel :per-page="1" class="carousel" v-else>
      <slide>
        <div class="slide-item slide-item3">
          <div class="slide-content">
            <div class="slide-txt">
              <p class="slide-title">{{$t('auth.carousel.singleslide.title')}}</p>
              <p>{{$t('auth.carousel.singleslide.text0')}}</p>
            </div>
          </div>
        </div>
      </slide>
    </carousel>

    <div class="language-wrapper">
      <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
        <a class="a-icon" href.prevent>
          <p class="locale">{{ this.$i18n.locale }}</p>
          <i class="material-icons">keyboard_arrow_down</i>
        </a>
        <vs-dropdown-menu class="select-lang">
          <vs-dropdown-item v-for="lang in locales" :key="lang" :class="lang" @click="changeLocale(lang)">
            <p>{{ lang }}</p>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'component-carousel',

  components: {
    Carousel,
    Slide
  },

  props: {
   authType: {
    type: String,
    required: true
   }
  },

  data(){
    return {
      locales: ['en', 'fr', 'de', 'es', 'pt'],
    }
  },
  
  methods: {
    changeLocale(lang) {
      localStorage.setItem('language', lang)
      this.$i18n.locale = lang
    },
  },
}    
</script>